import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NbToastrService } from '@nebular/theme';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-eft-payment-success-handler',
  templateUrl: './eft-payment-success-handler.component.html',
  styleUrls: ['./eft-payment-success-handler.component.scss'],
})
export class EftPaymentSuccessHandlerComponent implements OnInit {
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private toastrService: NbToastrService,
  ) {}

  async ngOnInit() {
    const params = (await this.activatedRoute.params.pipe(take(1)).toPromise()) as { numOfCreditsPurchased: string };
    const numOfCreditsPurchased = +params.numOfCreditsPurchased;
    this.toastrService.success(`Topped up with ${numOfCreditsPurchased} credits`, 'Success');
    this.router.navigate(['/home/convert']);
  }
}
